export default __webpack_public_path__ + "static/unicorn-site-952f4adf25ea20321defad6695740e19.png";